(function () {
  'use strict';

  const money = (cents, format) => {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, format);
    return '$' + (cents / 100).toFixed(2);
  };

  // ============ Gallery (carousel) ============
  function initGallery(root) {
    if (root.__pdpGalleryInited) return;
    root.__pdpGalleryInited = true;

    const viewport = root.querySelector('[data-pdp-gallery-viewport]');
    const slides = root.querySelectorAll('.pdp-gallery__slide');
    const prev = root.querySelector('[data-pdp-gallery-prev]');
    const next = root.querySelector('[data-pdp-gallery-next]');
    const dots = root.querySelectorAll('[data-pdp-gallery-dot]');
    const thumbs = root.querySelectorAll('[data-pdp-gallery-thumb]');
    const counter = root.querySelector('[data-pdp-gallery-counter]');
    const total = slides.length;
    if (!viewport || total === 0) return;

    let current = 0;

    const fmt = (i) => String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');

    const sync = (i) => {
      current = i;
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      if (counter) counter.textContent = fmt(i);
    };

    const goTo = (i, smooth = true) => {
      const bounded = ((i % total) + total) % total;
      const slide = slides[bounded];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      sync(bounded);
    };

    prev?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((d) => d.addEventListener('click', () => {
      const i = parseInt(d.dataset.index, 10);
      if (!Number.isNaN(i)) goTo(i);
    }));
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = parseInt(t.dataset.index, 10);
      if (!Number.isNaN(i)) goTo(i);
    }));

    let scrollTimer;
    viewport.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const i = Math.round(viewport.scrollLeft / viewport.clientWidth);
        if (i !== current) sync(i);
      }, 80);
    }, { passive: true });

    root.__pdpGotoByMediaId = (id) => {
      if (id == null) return;
      const target = String(id);
      const slide = root.querySelector('[data-media-id="' + target + '"]');
      if (!slide) return;
      const idx = Array.prototype.indexOf.call(slides, slide);
      if (idx >= 0 && idx !== current) goTo(idx);
    };

    if (counter) counter.textContent = fmt(0);
  }

  // ============ Buy Box / Variant picker ============
  function initBuy(root) {
    if (root.__pdpBuyInited) return;
    root.__pdpBuyInited = true;
    const form = root.querySelector('[data-pdp-form]') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const productJsonEl = root.querySelector('[data-pdp-product-json]');
    if (!productJsonEl) return;
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

    const variantIdInput = form.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const compareEl = root.querySelector('[data-pdp-compare]');
    const savingsEl = root.querySelector('[data-pdp-savings]');
    const saleTagEl = root.querySelector('[data-pdp-sale-tag]');
    const paymentTermsEl = root.querySelector('[data-pdp-installments] shopify-payment-terms');
    const atcBtn = root.querySelector('[data-pdp-atc]');
    const atcTotalEl = root.querySelector('[data-pdp-atc-total]');
    const atcTextEl = root.querySelector('[data-pdp-atc-text]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const optGroups = root.querySelectorAll('[data-pdp-opt-group]');
    const selectedLabels = root.querySelectorAll('[data-pdp-opt-selected]');
    const stickyPrice = document.querySelector('[data-pdp-sticky-price]');
    const stickyCompare = document.querySelector('[data-pdp-sticky-compare]');
    const stickySub = document.querySelector('[data-pdp-sticky-sub]');
    const gallery = document.querySelector('[data-pdp-gallery]');

    let selected = {};
    optGroups.forEach(g => {
      const name = g.dataset.optName;
      if (g.tagName === 'SELECT') {
        selected[name] = g.value;
      } else {
        const sel = g.querySelector('.pdp-opt__btn.is-selected');
        if (sel) selected[name] = sel.dataset.optValue;
      }
    });

    const sizeMatrix = {};
    const sizeMatrixEl = root.querySelector('script[data-pdp-size-matrix]');
    if (sizeMatrixEl) {
      try {
        const arr = JSON.parse(sizeMatrixEl.textContent);
        if (Array.isArray(arr)) {
          arr.forEach(entry => {
            if (Array.isArray(entry) && entry.length === 3) {
              sizeMatrix[entry[0] + '||' + entry[1]] = entry[2];
            }
          });
        }
      } catch (e) {}
    }
    const hasSizeMatrix = Object.keys(sizeMatrix).length > 0;

    const relabelSizeOptionsByOrientation = () => {
      if (!hasSizeMatrix) return;
      let orient = '';
      for (const k of Object.keys(selected)) {
        if (k.toLowerCase().indexOf('orientation') !== -1) { orient = selected[k]; break; }
      }
      if (!orient) return;
      optGroups.forEach(g => {
        const name = g.dataset.optName || '';
        if (name.toLowerCase().indexOf('size') === -1) return;
        if (g.tagName !== 'SELECT') return;
        g.querySelectorAll('option').forEach(opt => {
          const sv = opt.value;
          const dim = sizeMatrix[orient + '||' + sv];
          opt.textContent = dim ? (sv + ' — ' + dim) : sv;
        });
      });
    };

    const findVariant = () => {
      const optNames = product.options.map(o => typeof o === 'string' ? o : o.name);
      return product.variants.find(v => {
        return optNames.every((n, i) => {
          const val = selected[n];
          return v.options[i] === val;
        });
      });
    };

    const updateOptionAvailability = () => {
      optGroups.forEach(g => {
        const name = g.dataset.optName;
        const check = (val) => {
          const trial = { ...selected, [name]: val };
          return product.variants.find(variant =>
            product.options.every((o, i) => {
              const n = typeof o === 'string' ? o : o.name;
              return variant.options[i] === trial[n];
            })
          );
        };
        if (g.tagName === 'SELECT') {
          g.querySelectorAll('option').forEach(opt => {
            const v = check(opt.value);
            opt.disabled = !(v && v.available);
          });
        } else {
          g.querySelectorAll('.pdp-opt__btn').forEach(btn => {
            const v = check(btn.dataset.optValue);
            btn.disabled = !(v && v.available);
          });
        }
      });
    };

    const updateUI = () => {
      const v = findVariant();
      if (!v) {
        atcBtn.disabled = true;
        atcTextEl.textContent = 'Unavailable';
        return;
      }
      variantIdInput.value = v.id;
      atcBtn.disabled = !v.available;
      atcTextEl.textContent = v.available ? (atcBtn.dataset.labelAdd || 'Add to Cart') : 'Sold Out';
      const manualSale = root.dataset.manualSale === 'true';
      const manualPct = parseInt(root.dataset.manualSalePercent, 10) || 0;
      let onSale = false, displayPrice = v.price, displayCompare = 0, displaySavingsPct = 0;
      if (manualSale && manualPct > 0) {
        onSale = true;
        displayPrice = Math.round(v.price * (100 - manualPct) / 100);
        displayCompare = v.price;
        displaySavingsPct = manualPct;
      } else if (v.compare_at_price && v.compare_at_price > v.price) {
        onSale = true;
        displayCompare = v.compare_at_price;
        displaySavingsPct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
      }
      if (priceEl) priceEl.innerHTML = money(displayPrice);
      if (compareEl) {
        if (onSale) {
          compareEl.innerHTML = money(displayCompare);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (savingsEl) {
        if (onSale) {
          savingsEl.textContent = 'Save ' + displaySavingsPct + '%';
          savingsEl.removeAttribute('hidden');
        } else {
          savingsEl.setAttribute('hidden', '');
        }
      }
      if (saleTagEl) {
        if (onSale) saleTagEl.removeAttribute('hidden');
        else saleTagEl.setAttribute('hidden', '');
      }
      if (paymentTermsEl) {
        paymentTermsEl.setAttribute('variant-id', String(v.id));
      }
      const qty = parseInt(qtyInput.value, 10) || 1;
      if (atcTotalEl) atcTotalEl.innerHTML = money(displayPrice * qty);
      selectedLabels.forEach(el => {
        const name = el.dataset.optName;
        if (selected[name]) el.textContent = selected[name];
      });
      if (stickyPrice) stickyPrice.innerHTML = money(displayPrice);
      if (stickyCompare) {
        if (onSale) {
          stickyCompare.innerHTML = money(displayCompare);
          stickyCompare.removeAttribute('hidden');
        } else {
          stickyCompare.setAttribute('hidden', '');
        }
      }
      if (stickySub) {
        stickySub.textContent = Object.values(selected).join(' · ');
      }
      const variantMediaId = v.featured_media?.id || v.featured_image?.id;
      if (variantMediaId && gallery && gallery.__pdpGotoByMediaId) {
        gallery.__pdpGotoByMediaId(variantMediaId);
      }
      relabelSizeOptionsByOrientation();
      updateOptionAvailability();
      // Update URL variant param non-destructively
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    };

    optGroups.forEach(g => {
      const name = g.dataset.optName;
      if (g.tagName === 'SELECT') {
        g.addEventListener('change', () => {
          selected[name] = g.value;
          updateUI();
        });
      } else {
        g.addEventListener('click', e => {
          const btn = e.target.closest('.pdp-opt__btn');
          if (!btn || btn.disabled) return;
          selected[name] = btn.dataset.optValue;
          g.querySelectorAll('.pdp-opt__btn').forEach(b => b.classList.toggle('is-selected', b === btn));
          updateUI();
        });
      }
    });

    // Qty
    root.querySelectorAll('[data-pdp-qty-dec]').forEach(b => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      updateUI();
    }));
    root.querySelectorAll('[data-pdp-qty-inc]').forEach(b => b.addEventListener('click', () => {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      updateUI();
    }));
    qtyInput?.addEventListener('input', updateUI);

    // AJAX add to cart
    form.addEventListener('submit', e => {
      e.preventDefault();
      const v = findVariant();
      if (!v || !v.available) return;
      const fd = new FormData(form);
      atcBtn.disabled = true;
      const origText = atcTextEl.textContent;
      atcTextEl.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' },
      }).then(r => r.json()).then(item => {
        atcBtn.classList.add('is-added');
        atcTextEl.textContent = 'Added ✓';
        const qty = parseInt(qtyInput?.value, 10) || 1;
        const detail = { item, variant: v, product: window.__pdpProduct || null, quantity: qty };
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:add', { detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('product:added', { detail, bubbles: true }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined,
            items: [{
              item_id: v.sku || String(v.id),
              item_variant_id: v.id,
              item_name: (item && item.product_title) || (v.name || '').split(' - ')[0],
              item_variant: v.title,
              price: (v.price || 0) / 100,
              quantity: qty,
            }],
          },
        });
        setTimeout(() => {
          atcBtn.classList.remove('is-added');
          atcTextEl.textContent = origText;
          atcBtn.disabled = false;
        }, 2000);
      }).catch(() => {
        atcTextEl.textContent = origText;
        atcBtn.disabled = false;
      });
    });

    updateUI();
  }

  // ============ Sticky Buy Bar ============
  function initStickyBar() {
    if (window.__pdpStickyBarInited) return;
    window.__pdpStickyBarInited = true;
    const bar = document.querySelector('[data-pdp-sticky-bar]');
    const trigger = document.querySelector('[data-pdp-buy-box]');
    if (!bar || !trigger) return;

    const buyBoxObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        const visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }, { rootMargin: '0px' });
    buyBoxObs.observe(trigger);

    // Translate the bar up so its bottom edge tracks the top of the footer
    // once the footer scrolls into view — keeps the bar visible but never
    // covers the footer links.
    const footer = document.querySelector('.footer');
    if (footer) {
      let raf = 0;
      const updateOffset = () => {
        raf = 0;
        const overlap = Math.max(0, window.innerHeight - footer.getBoundingClientRect().top);
        bar.style.transform = overlap > 0 ? 'translateY(-' + overlap + 'px)' : '';
      };
      const schedule = () => {
        if (!raf) raf = window.requestAnimationFrame(updateOffset);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      updateOffset();
    }

    const stickyAtc = bar.querySelector('[data-pdp-sticky-atc]');
    stickyAtc?.addEventListener('click', () => {
      const mainAtc = document.querySelector('[data-pdp-atc]');
      mainAtc?.closest('form')?.requestSubmit();
    });
  }

  // ============ Size Visualizer ============
  function initVisualizer(root) {
    if (root.__pdpVisualizerInited) return;
    root.__pdpVisualizerInited = true;
    const buttons = root.querySelectorAll('[data-pdp-size-btn]');
    const frame = root.querySelector('[data-pdp-size-frame]');
    const hLine = root.querySelector('[data-pdp-size-h-line]');
    const wLine = root.querySelector('[data-pdp-size-w-line]');
    const hLabel = root.querySelector('[data-pdp-size-h-label]');
    const wLabel = root.querySelector('[data-pdp-size-w-label]');
    const image = root.querySelector('[data-pdp-size-image]');

    const SCALE = 10; // px per inch
    const CX = 780;
    const FLOOR = 480;
    const BOTTOM = FLOOR - 140;

    const setSize = (w, h) => {
      const wPx = w * SCALE;
      const hPx = h * SCALE;
      frame.setAttribute('x', CX - wPx / 2);
      frame.setAttribute('y', BOTTOM - hPx);
      frame.setAttribute('width', wPx);
      frame.setAttribute('height', hPx);
      if (image) {
        image.setAttribute('x', CX - wPx / 2 + 8);
        image.setAttribute('y', BOTTOM - hPx + 8);
        image.setAttribute('width', wPx - 16);
        image.setAttribute('height', hPx - 16);
      }
      hLine.setAttribute('x1', CX - wPx / 2 - 30);
      hLine.setAttribute('x2', CX - wPx / 2 - 30);
      hLine.setAttribute('y1', BOTTOM);
      hLine.setAttribute('y2', BOTTOM - hPx);
      hLabel.setAttribute('x', CX - wPx / 2 - 40);
      hLabel.setAttribute('y', BOTTOM - hPx / 2);
      hLabel.textContent = h + '"';
      wLine.setAttribute('x1', CX - wPx / 2);
      wLine.setAttribute('x2', CX + wPx / 2);
      wLine.setAttribute('y1', BOTTOM + 22);
      wLine.setAttribute('y2', BOTTOM + 22);
      wLabel.setAttribute('x', CX);
      wLabel.setAttribute('y', BOTTOM + 38);
      wLabel.textContent = w + '"';
    };

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        const w = parseFloat(btn.dataset.w);
        const h = parseFloat(btn.dataset.h);
        setSize(w, h);
      });
    });

    const init = root.querySelector('[data-pdp-size-btn].is-active') || buttons[0];
    if (init) {
      init.classList.add('is-active');
      setSize(parseFloat(init.dataset.w), parseFloat(init.dataset.h));
    }
  }

  // ============ Modal (sizing guide) ============
  function initModal() {
    if (window.__pdpModalInited) return;
    window.__pdpModalInited = true;
    document.addEventListener('click', e => {
      const opener = e.target.closest('[data-pdp-modal-open]');
      if (opener) {
        e.preventDefault();
        const id = opener.dataset.pdpModalOpen;
        const m = document.getElementById(id);
        m?.classList.add('is-open');
        return;
      }
      const closer = e.target.closest('[data-pdp-modal-close]');
      if (closer) {
        closer.closest('.pdp-modal')?.classList.remove('is-open');
        return;
      }
      const backdrop = e.target.classList?.contains('pdp-modal');
      if (backdrop) e.target.classList.remove('is-open');
    });
  }

  // ============ FAQ accordion ============
  // Uses native <details> elements — no JS needed for open/close.
  // Optional: collapse others when one opens.
  function initFaq(root) {
    if (root.__pdpFaqInited) return;
    root.__pdpFaqInited = true;
    const items = root.querySelectorAll('details.pdp-faq__item');
    items.forEach(d => {
      d.addEventListener('toggle', () => {
        if (d.open) items.forEach(o => { if (o !== d) o.open = false; });
      });
    });
  }

  // ============ Read-more description ============
  function initReadMore(root) {
    if (root.__pdpReadMoreInited) return;
    root.__pdpReadMoreInited = true;
    const btn = root.querySelector('[data-pdp-desc-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-pdp-desc]');
      if (!wrap) return;
      const expanded = wrap.classList.toggle('is-expanded');
      btn.textContent = expanded ? (btn.dataset.labelLess || 'Show less') : (btn.dataset.labelMore || 'Read more');
      btn.setAttribute('aria-expanded', String(expanded));
    });
  }

  // ============ Boot ============
  function boot() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pdp-buy-box]').forEach(initBuy);
    document.querySelectorAll('[data-pdp-visualizer]').forEach(initVisualizer);
    document.querySelectorAll('[data-pdp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-pdp-desc]').forEach(initReadMore);
    initStickyBar();
    initModal();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
